import { useEffect, useState } from "react";

import { getProjectsHomeCardColumnCount } from "./projectHomeHelpers";

/**
 * Track Projects Home card column count at Tailwind ``md`` / ``xl`` breakpoints.
 *
 * @returns {1|2|3}
 */
export default function useProjectsHomeCardColumnCount() {
  const [columnCount, setColumnCount] = useState(() =>
    getProjectsHomeCardColumnCount()
  );

  useEffect(() => {
    const mediaMd = window.matchMedia("(min-width: 768px)");
    const mediaXl = window.matchMedia("(min-width: 1280px)");

    /**
     * Recompute card columns from the current viewport width.
     *
     * @returns {void}
     */
    const updateColumnCount = () => {
      setColumnCount(getProjectsHomeCardColumnCount(window.innerWidth));
    };

    updateColumnCount();
    mediaMd.addEventListener("change", updateColumnCount);
    mediaXl.addEventListener("change", updateColumnCount);
    return () => {
      mediaMd.removeEventListener("change", updateColumnCount);
      mediaXl.removeEventListener("change", updateColumnCount);
    };
  }, []);

  return columnCount;
}
